import { cache, useState } from 'react';
import useBackend from '@/backend';
import { useUserStoreActions } from '@/store';

interface Response {
	success: boolean | null;
	error: string | null;
}

/* --------------------------------- OPTIONS -------------------------------- */

const route = '/avatars';

const headers = {
	'Content-Type': 'application/json',
};

/* -------------------------------------------------------------------------- */

export const useGetAvatars = () => {
	const { setAvatars } = useUserStoreActions();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const { url_V3, getAccessToken } = useBackend();
	const getAvatars = cache(async (): Promise<Response> => {
		setLoading(true);
		setError(null);

		const apiUrl = `${url_V3}${route}`;

		try {
			const response = await fetch(apiUrl, {
				method: 'GET',
				headers,
			});

			/* -------------------------------------------------------------------------- */
			const data = await response.json();

			if (!data?.success) {
				throw new Error('Failed to load');
			}

			const formattedData = data?.data?.avatars;

			// /* -------------------------------------------------------------------------- */
			setAvatars(formattedData);

			return formattedData;
		} catch (e: unknown) {
			const message = e instanceof Error ? e.message : 'Unknown error';
			setError(message);
			if (e instanceof Error) return { success: null, error: e.message };

			return { success: null, error: 'Failed to load' };
		} finally {
			setLoading(false);
		}
	});
	return {
		loading,
		error,
		getAvatars,
	};
};
